const initialState = {
    selected_processor: '',
    selected_cpu_cooler: '',
    selected_motherboard: '',
    selected_ram: '',
    selected_gpu: '',
    selected_psu: '',
    selected_case_cooler: '',
    selected_monitor: '',
    total_price: 0,
    token: '',
    email: ''
}

export default initialState;